export const SET_COACH_POSITION = 'SET_COACH_POSITION';

export const SET_COACH_GROUP = 'SET_COACH_GROUP';

export const SET_MEMBERSHIP_POSITION = 'SET_MEMBERSHIP_POSITION';

export const SET_MEMBERSHIP_GROUP = 'SET_MEMBERSHIP_GROUP';

export const SET_ADMIN_INFO = 'SET_ADMIN_INFO';

export const SET_RECEIPT_AUTH = 'SET_RECEIPT_AUTH';

export const SET_COACH_LIST = 'SET_COACH_LIST';

export const SET_PT_COACH_LIST = 'SET_PT_COACH_LIST';

export const SET_SWIM_COACH_LIST = "SET_SWIM_COACH_LIST";

export const SET_MEMBERSHIP_LIST = 'SET_MEMBERSHIP_LIST';

export const CARD_SETTING_AUTH = 'CARD_SETTING_AUTH';

export const SET_PAGER_STACK = 'SET_PAGER_STACK';

export const ADD_GOODS_ITEM = 'ADD_GOODS_ITEM';

export const SET_GOODS_LIST = 'SET_GOODS_LIST';

export const DELETE_GOODS_ITEM = 'DELETE_GOODS_ITEM';

export const CLEAR_GOODS_CART = 'CLEAR_GOODS_CART';

export const SET_COACH_GROUP_LIST = 'SET_COACH_GROUP_LIST';
export const SET_SWIM_GROUP_LIST = 'SET_SWIM_GROUP_LIST';

export const SET_BUS_IMAGES = 'SET_BUS_IMAGES';

export const SET_INVENTORY_CODE = 'SET_INVENTORY_CODE';

export const SET_INVENTORY_LIST = 'SET_INVENTORY_LIST';

export const SET_CAT_LIST = 'SET_CAT_LIST'

export const SET_USER_DETAIL_INFO = 'SET_USER_DETAIL_INFO'
